import { Component, Inject, OnInit } from '@angular/core';
// Force rebuild
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Visit, VisitType, VisitStatus } from '../../models/visit';
import { ImmobilierService } from '../../services/immobilier.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-add-edit-visit-dialog',
    templateUrl: './add-edit-visit-dialog.component.html',
    styleUrls: ['./add-edit-visit-dialog.component.css']
})
export class AddEditVisitDialogComponent implements OnInit {

    visit: Visit;
    isNew: boolean = true;
    properties: any[] = [];
    clients: any[] = [];
    users: any[] = [];

    // Dropdown options
    visitTypes: VisitType[] = ['physique', 'virtuelle'];

    // Custom Stepper
    currentStep = 0;
    steps: string[] = [
        'Informations Générales',
        'Détails Logistiques',
        'Notifications'
    ];

    constructor(
        public dialogRef: MatDialogRef<AddEditVisitDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private immobilierService: ImmobilierService,
        private snackBar: MatSnackBar
    ) {
        if (data && data.visit) {
            this.visit = { ...data.visit };
            this.isNew = false;
        } else {
            this.isNew = true;
            this.visit = {
                id: 0,
                propertyId: 0,
                clientId: 0,
                type: 'physique',
                visitDate: new Date(),
                visitTime: '10:00',
                duration: 30,
                status: 'planifiee',
                notifyEmail: true,
                notifySms: false,
                createdAt: new Date(),
                updatedAt: new Date()
            };
        }
    }

    ngOnInit(): void {
        this.loadProperties();
        this.loadClients();
        this.loadUsers();
    }

    loadClients(): void {
        this.immobilierService.getClients().subscribe({
            next: (clients) => {
                this.clients = clients;
            }
        });
    }

    loadUsers(): void {
        this.immobilierService.getUsers().subscribe({
            next: (users) => {
                this.users = users;
            },
            error: (err) => console.error('Erreur lors du chargement des utilisateurs:', err)
        });
    }

    loadProperties(): void {
        this.immobilierService.getProperties().subscribe({
            next: (properties) => {
                this.properties = properties;
            }
        });
    }

    // Stepper Navigation
    nextStep(): void {
        if (this.currentStep < this.steps.length - 1) {
            this.currentStep++;
        }
    }

    prevStep(): void {
        if (this.currentStep > 0) {
            this.currentStep--;
        }
    }

    setStep(index: number): void {
        this.currentStep = index;
    }

    // Actions
    save(): void {
        // Update property info based on selection
        const selectedProperty = this.properties.find(p => p.id === this.visit.propertyId);
        if (selectedProperty) {
            this.visit.propertyReference = selectedProperty.reference;
        }

        // Update client info based on selection
        const selectedClient = this.clients.find(c => c.id === this.visit.clientId);
        if (selectedClient) {
            this.visit.clientName = selectedClient.firstName + ' ' + selectedClient.lastName;
        }

        // Update agent info based on selection
        if (this.visit.agentId) {
            const selectedAgent = this.users.find(u => u.id === this.visit.agentId);
            if (selectedAgent) {
                this.visit.agentName = selectedAgent.first_name + ' ' + selectedAgent.last_name;
            }
        }

        if (this.isNew) {
            this.immobilierService.createVisit(this.visit).subscribe({
                next: (res) => {
                    this.snackBar.open('Visite planifiée avec succès', 'Fermer', { duration: 3000 });
                    this.dialogRef.close(res);
                },
                error: (err) => {
                    console.error(err);
                    this.snackBar.open('Erreur lors de la planification', 'Fermer', { duration: 3000 });
                }
            });
        } else {
            this.immobilierService.updateVisit(this.visit.id, this.visit).subscribe({
                next: (res) => {
                    this.snackBar.open('Visite modifiée avec succès', 'Fermer', { duration: 3000 });
                    this.dialogRef.close(res);
                },
                error: (err) => {
                    console.error(err);
                    this.snackBar.open('Erreur lors de la modification', 'Fermer', { duration: 3000 });
                }
            });
        }
    }

    cancel(): void {
        this.dialogRef.close();
    }
}
